import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import ColorProvider from '../chrome/ColorProvider';
import Heading from '../chrome/Heading';
import Text from '../chrome/Text';

const valueContainerBaseStyles = ({ theme }) => css`
  display: flex;
  margin-bottom: ${theme.spacings.bit};
`;

const ValueContainer = styled('div')(valueContainerBaseStyles);

const styledHeadingStyles = ({ theme }) => css`
  margin-top: ${theme.spacings.bit};
  margin-right: ${theme.spacings.bit};
  line-height: 35px;
`;

const StyledHeading = styled(Heading)(styledHeadingStyles);

const styledSuffixStyles = () => css`
  line-height: 24px;
  margin-top: 6px;
`;

const StyledSuffix = styled(Heading)(styledSuffixStyles);

const styledTextStyles = () => css`
  line-height: 14px;
`;

const StyledText = styled(Text)(styledTextStyles);

const Statistic = ({ valueColor, valueTextSize, value, suffixTextSize, suffix, titleColor, titleTextSize, title }) => (
  <>
    <ValueContainer>
      <ColorProvider variant={valueColor}>
        <StyledHeading variant='subHeadings' as='h3' weight='default' size={valueTextSize} noMarginBoth>
          {value}
        </StyledHeading>
      </ColorProvider>
      {suffix && (
        <ColorProvider variant={valueColor}>
          <StyledSuffix as='h4' size={suffixTextSize} noMarginBoth>
            {suffix}
          </StyledSuffix>
        </ColorProvider>
      )}
    </ValueContainer>
    {title && (
      <ColorProvider variant={titleColor}>
        <StyledText as='span' size={titleTextSize} noMargin>
          {title}
        </StyledText>
      </ColorProvider>
    )}
  </>
);

Statistic.propTypes = {
  valueColor: PropTypes.string,
  value: PropTypes.string,
  valueTextSize: PropTypes.string,
  suffix: PropTypes.string,
  suffixTextSize: PropTypes.string,
  titleColor: PropTypes.string,
  title: PropTypes.string,
  titleTextSize: PropTypes.string,
};

Statistic.defaultProps = {
  valueTextSize: 'exa',
  value: '96',
  valueColor: 'white',
  suffix: '%',
  suffixTextSize: 'tera',
  title: 'pick <br />accuracy',
  titleColor: 'lightGrey',
  titleTextSize: 'giga',
};

export default Statistic;
